// extracted by mini-css-extract-plugin
export default {"root":"Informative_root__TfhA2"};